export const WEB3_GET_PROVIDER = 'WEB3_GET_PROVIDER';
export const WEB3_NULL_PROVIDER = 'WEB3_NULL_PROVIDER';